import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { useDayPicker } from 'contexts/DayPicker';
/** Render the content of the day cell. */
export function DayContent(props) {
    var _a = useDayPicker(), locale = _a.locale, formatDay = _a.formatters.formatDay;
    return _jsx(_Fragment, { children: formatDay(props.date, { locale: locale }) });
}
//# sourceMappingURL=DayContent.js.map